export default ({ className, ...htmlAttributes }: { className?: string }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 576 512"
		fill="currenColor"
		className={className}
		{...htmlAttributes}
	>
		<path d="M0 0H16 144h16V32H144 32V144v16H0V144 16 0zM128 128h32V384H128V128zm64 0h32V384H192V128zM416 384V128h32V384H416zM288 128V384H256V128h32zm48 0h32V384H336V128zM560 0h16V16 144v16H544V144 32H432 416V0h16H560zM0 512V496 368 352H32v16V480H144h16v32H144 16 0zm560 0H432 416V480h16H544V368 352h32v16V496v16H560z" />
	</svg>
);
